<template>
  <div :class="{'container-list': !isMenuMiniSize, 'container-list-thin-menu': isMenuMiniSize}">
    <input type="hidden" id="copy-code" :value="copyUrl">
    <div class="video-header" style="display: flex;">
      <h2 style="font-weight: 600;">
        <span class="mdi mdi-camcorder-box" style="margin-right: 4px;"></span>ウェブ会議
      </h2>
      <div style="display: flex;">
        <button class="button" style="margin-right: 8px;"
          @click="isSetting = !isSetting" v-if="isStart">
          <span class="mdi mdi-settings" style="margin-right: 4px;"></span>設定
        </button>
        <button class="button" style="margin-right: 8px;"
          @click="isMemo = !isMemo">
          <span class="mdi mdi-account-edit" style="margin-right: 4px;"></span>メモ
        </button>
        <button class="button" style="margin-right: 8px; position: relative;"
          @click="changeChatModal(!isShowChat)"
          v-if="isStart">
          <div class="total-unread" v-if="unRead.count > 0">
            <p>{{unRead.count < 10 ? unRead.count : '9+'}}</p>
          </div>
          <span class="mdi mdi-comment-processing-outline" style="margin-right: 4px;"></span>チャット
        </button>
      </div>
    </div>
    <div class="drawer-back" @click="isMemo = false" v-if="isMemo"></div>
    <transition name="right">
      <div class="drawer-menu" v-if="isMemo">
        <h2 style="margin-bottom: 4px; font-weight: 600; text-align: left;">
          <span class="mdi mdi-account-edit" style="margin-right: 8px;"></span>メモ
        </h2>
        <p style="margin-bottom: 8px; font-size: smaller; color: #666; text-align: left;">
          面接の際の事前確認事項などの<br>メモとしてご利用いただけます。
        </p>
        <textarea v-model="user.interview_memo"
          placeholder="メモを記載"
          style="border: solid thin #ccc; padding: 16px; width: 100%; height: calc(100% - 128px); font-size: larger; overflow-y: scroll;">
        </textarea>
        <button @click="setProfile({'interview_memo': user.interview_memo}, 'profile')"
          class="button is-fullwidth">
          <span>保存</span>
        </button>
      </div>
    </transition>
    <div class="drawer-back" style="background: transparent;"
      @click="isSetting = false"
      v-if="isSetting">
    </div>
    <!-- チャット -->
    <transition name="chat">
      <ModalChat
        class="chat-view"
        @cancel="changeChatModal"
        @sendMessage="sendMessage"
        @unReadChange="unReadChange"
        :inputs="inputs"
        :unRead="unRead"
        :chatMessages="chatMessages"
        v-if="isShowChat"
      />
    </transition>
    <transition name="right">
      <div class="drawer-menu" v-if="isSetting">
        <h2 style="margin-bottom: 4px; font-weight: 600; text-align: left;">
          <span class="mdi mdi-message" style="margin-right: 8px;"></span>動画リンク設定
        </h2>
        <p style="margin-bottom: 8px; font-size: smaller; color: #666; text-align: left;">
          合言葉を決める事で、知らない人の参加を防ぐことができます。（設定がない場合は入力なしで通話可能になります。）
        </p>
        <br><br>
        <div style="display: flex;">
          <input placeholder="合言葉を入力" class="input"
            style="width: 70%; border-bottom-right-radius: 0; border-top-right-radius: 0;"
            v-model="user.aikotoba"/>
          <button @click="setProfile({'aikotoba': user.aikotoba}, 'profile')"
          style="width: 30%; border-top-left-radius: 0; border-bottom-left-radius: 0;"
            class="button is-primary">設定する</button>
        </div>
        <hr>
        <button class="button is-fullwidth" id="btn_connect" type="button"
          @click="isSetting=false">
          <span class="mdi mdi-close" style="margin-right: 4px;"></span>閉じる
        </button>
      </div>
    </transition>
    <div class="video-body" :class="{'-black': isStart}">
      <div class="start-box" v-if="!isStart && prepareStep==0">
        <p style="text-align: left;">
          共有リンクをコピーして、通話したい人にリンクをお送りすることで、ウェブ会議をスタートすることができます。
        </p>
        <a style="text-align: left;"
          @click="copyLink()">
          <span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>共有リンクをコピーする
        </a>
        <br>
        <p style="text-align: left;">合言葉を決める事で、知らない人の参加を防ぐことができます。（設定がない場合は入力なしで通話可能になります。）</p>
        <br>
        <div style="display: flex;">
          <input placeholder="合言葉を入力" class="input"
            style="width: 70%; border-bottom-right-radius: 0; border-top-right-radius: 0;"
            v-model="user.aikotoba"/>
          <button @click="setProfile({'aikotoba': user.aikotoba}, 'profile')"
            style="width: 30%; border-top-left-radius: 0; border-bottom-left-radius: 0;"
            class="button is-primary">
            設定する
          </button>
        </div>
        <hr>
        <div style="height: 76px; margin-bottom: 10px;">
          <p style="font-weight: 600; padding: 8px;">お名前を入力してください</p>
          <input placeholder="入力..." class="input" v-model="inputs.inputName"/>
        </div>
        <button class="button"
          style="height: 48px; background: green; color: white;"
          id="btn_connect"
          type="button"
          @click="nextStep()">
          <span class="mdi mdi-camcorder mdi-24px" style="margin-right: 16px;"></span>参加する
        </button>
      </div>
      <div class="start-box" v-if="!isStart && prepareStep==1">
        <div style="text-align: left; color: #C82E42; padding-bottom: 10px; cursor: pointer;" @click="prevStep()">戻る</div>
        <video @loadeddata="playVideo"
          id="pre_local_video"
          style="height: 300px; width: 100%;"
          muted
          playsinline
          autoplay></video>
        <button class="mute-button"
          id="btn_mute"
          style="position: absolute; left: calc(50% - 79px); top: 282px;" type="button"
          @click="$store.dispatch('webRTC/setAudioSwitch', false)"
          v-if="!isMute">
          <span class="mdi mdi-microphone mdi-24px"></span>
        </button>
        <button class="mute-button"
          id="btn_mute" style="position: absolute; left: calc(50% - 79px); top: 282px;"
          type="button"
          @click="$store.dispatch('webRTC/setAudioSwitch', true)"
          v-if="isMute">
          <span class="mdi mdi-microphone-off mdi-24px"></span>
        </button>
        <button class="blind-button"
          id="btn_blind"
          style="position: absolute; left: calc(50% - 15px); top: 282px;"
          type="button"
          @click="$store.dispatch('webRTC/setVideoSwitch', false)"
          v-if="!isBlind">
          <span class="mdi mdi-camcorder mdi-24px"></span>
        </button>
        <button class="blind-button"
          id="btn_blind"
          style="position: absolute; left: calc(50% - 15px); top: 282px;"
          type="button"
          @click="$store.dispatch('webRTC/setVideoSwitch', true)"
          v-if="isBlind">
          <span class="mdi mdi-camcorder-off mdi-24px"></span>
        </button>
        <div style="width: 100%">
          <div style="text-align: center;">
            現在通話中の人数: {{memberNum}}
          </div>
        </div>
        <hr>
        <button class="button"
          style="height: 48px; background: green; color: white;"
          id="btn_connect"
          type="button"
          @click="startConnect()">
          <span class="mdi mdi-camcorder mdi-24px"
            style="margin-right: 16px;"></span>通話する
        </button>
      </div>
      <!-- 自分の画像(音はミュートする) -->
      <video @loadeddata="playVideo"
        id="local_video_share"
        class="off-video"
        muted
        playsinline
        autoplay></video>
      <div :style="[getStyleVideo(remoteStreams.length + 1, -1), showStream(-1) ? '' : {'display': 'none'}]"
        class="video-frame"
        :class="{'big-video': bigId === -1, 'off-video': !isStart}"
        @mouseenter="onMouseStream(-1)"
        @mouseleave="outMouseStream(-1)"
        @click="bigVideo(-1)">
        <video @loadeddata="playVideo"
          id="local_video"
          class="video-size-remote"
          muted
          playsinline
          autoplay></video>
        <div class="mouse-over-blind" v-if="remoteStreams.length!=0 && mouseOverIndex==-1"></div>
        <div class="video-user-name">{{userName + (isMute ? '(ミュート)' : '')}}</div>
        <img src="@/assets/template/videoview-pin.png" class="mouse-over-pin"
          v-if="remoteStreams.length!=0 && mouseOverIndex==-1 && bigId==null">
        <img src="@/assets/template/videoview-pin-n.png" class="mouse-over-pin"
          v-if="remoteStreams.length!=0 && mouseOverIndex==-1 && bigId==-1">
      </div>
      <div v-for="(stream, i) in remoteStreams" :key="'stream-'+i"
        :style="[getStyleVideo(remoteStreams.length + 1, stream.id),
          showStream(stream.id) ? '' : {'display': 'none'}]"
        class="video-frame"
        :class="{'big-video': bigId === stream.id}"
        @mouseenter="onMouseStream(i)"
        @mouseleave="outMouseStream(i)"
        @click="bigVideo(stream.id)">
        <video @loadeddata="playVideo"
        :srcObject.prop="stream"
        class="video-size-remote"
        autoplay
        playsinline></video>
        <div class="mouse-over-blind" v-if="mouseOverIndex==i"></div>
        <div class="video-user-name">
          {{roomMembers[stream.peerId].name + (roomMembers[stream.peerId].mute && !roomMembers[stream.peerId].share
            ? '(ミュート)'
            : '')}}
          <div v-for="(value, peerId, idx) in unRead.by_person" :key="idx">
            <div class="unread" v-if="stream.peerId == peerId && value> 0">
              <p>{{value < 10 ? value : '9+'}}</p>
            </div>
          </div>
        </div>
        <img src="@/assets/template/videoview-pin.png"
          class="mouse-over-pin"
          v-if="mouseOverIndex==i && bigId==null">
        <img src="@/assets/template/videoview-pin-n.png"
          class="mouse-over-pin"
          v-if="mouseOverIndex==i && bigId==i">
      </div>
    </div>
    <div class="button-menu" v-if="isStart">
      <button class="setting-button" @click="shareScreen(!isShare)">
        <span class="mdi mdi-cast-off mdi-24px" v-if="isShare"></span>
        <span class="mdi mdi-cast-connected mdi-24px" v-else></span>
      </button>
      <button class="link-button" @click="copyLink()">
        <span class="mdi mdi-link-variant mdi-24px"></span>
      </button>
      <!-- 接続ボタン -->
      <button class="start-button" id="btn_connect" type="button"
        @click="startConnect()"
        v-if="!isStart">
        <span class="mdi mdi-camcorder mdi-24px"></span>
      </button>
      <!-- 切断ボタン -->
      <button class="hangup-button" id="btn_disconnect" type="button"
        @click="isStart = false; prepareStep=0;
        $store.dispatch('webRTC/waitingDisconnect');
        $store.dispatch('webRTC/endCall');"
        v-if="isStart">
        <span class="mdi mdi-phone-hangup mdi-24px"></span>
      </button>
      <button class="mute-button"
        id="btn_mute"
        type="button"
        @click="$store.dispatch('webRTC/setAudioSwitch', false)"
        v-if="!isMute">
        <span class="mdi mdi-microphone mdi-24px"></span>
      </button>
      <button class="mute-button"  id="btn_mute"  type="button"
        @click="$store.dispatch('webRTC/setAudioSwitch', true)"
        v-if="isMute">
        <span class="mdi mdi-microphone-off mdi-24px"></span>
      </button>
      <button class="blind-button" id="btn_blind" type="button"
        @click="$store.dispatch('webRTC/setVideoSwitch', false)"
        v-if="!isBlind">
        <span class="mdi mdi-camcorder mdi-24px"></span>
      </button>
      <button class="blind-button" id="btn_blind" type="button"
        @click="$store.dispatch('webRTC/setVideoSwitch', true)"
        v-if="isBlind">
        <span class="mdi mdi-camcorder-off mdi-24px"></span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import createUUID from "@/functions/createUUID"
import ModalChat from "@/components/VideoInterview/organisms/ModalChat"
import Peer from 'skyway-js'
export default {
  components: {
    ModalChat
  },
  data () {
    return {
      isStart: false,
      isSetting: false,
      isMemo: false,
      isShare: false,
      bigId: null,
      copyUrl: '',
      prepareStep: 0,
      mouseOverIndex: null,
      inputs: {
        inputAikotoba: null,
        inputName: null,
      },
      isShowChat: false,
      unRead: {
        index: -1,
        date: null,
        count: 0,
        by_person:null,
      },
    }
  },
  computed: {
    ...mapState('auth', ['user', 'error', 'success']),
    ...mapState('directtalk', ['applylist', 'isApplyListLoading', 'isApplyListNone', 'downloadCSV', 'isMakingCSV', 'resumeLoading', 'pdfFile', 'isOCRReading', 'ocrData']),
    ...mapState('webRTC', ['remoteStreams', 'memberNum', 'roomMembers', 'isMute', 'isBlind', 'waitingPeer', 'waitingRoom', 'userName', 'chatMessages', 'peerId', 'requestData', 'requestOnlyData']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  mounted () {
    this.inputs.inputName = this.user.username
    this.inputs.inputAikotoba = inputAikotoba
  },
  watch: {
    // 承認
    requestOnlyData () {
      this.displayJoinRequest()
    },
    prepareStep () {
      this.displayJoinRequest()
    },
    remoteStreams () {
      if (!this.remoteStreams.map((st) => st.id).includes(this.bigId)) this.bigId = null
      if (this.remoteStreams.length == 0) this.bigId = null
    },
    chatMessages () {
      if (this.unRead.date) {
        let index = this.$_.findIndex(
          this.chatMessages,
          ((m) => { return new Date(m.createdAt) > new Date(this.unRead.date) })
        )
      let count = this.chatMessages.length - index
      let unread_messages = this.chatMessages.slice(-count)
      let by_person = {}
        for (const elem of unread_messages) {
          let temp_key = elem['peerId']
          if(by_person[temp_key]) {
            by_person[temp_key] +=  1
          } else {
            by_person[temp_key] = 1;
          }
        }
        this.unReadChange({
          index: index,
          count: count,
          date:  null,
          by_person:by_person
        })
      } else {
        let count = this.chatMessages.length
        let unread_messages = this.chatMessages.slice(-count)
        let by_person = {}
          for (const elem of unread_messages) {
            let temp_key = elem['peerId']
            if(by_person[temp_key]) {
              by_person[temp_key] +=  1
            } else {
              by_person[temp_key] = 1;
            }
          }
        this.unReadChange({
          index: 0,
          count: count,
          date:  new Date(this.chatMessages[0].createdAt),
          by_person:by_person
        })
      }
      if (this.chatMessages.slice(-1)[0]['speaker'] == "other"){
        let music = new Audio();
        music.preload = "auto";
        music.src = require('@/assets/template/recieved_message.mp3');
        music.load();
        music.play();
      }
    }
  },
  methods: {
    displayJoinRequest () {
      if (this.$store.getters['auth/isClient'] && this.prepareStep === 1 && Object.keys(this.requestOnlyData).length !== 0) {
        let req = this.requestOnlyData
        if (!req.flg) {
          let music = new Audio();
          music.preload = "auto";
          music.src = require('@/assets/template/web_meeting_request.mp3');
          music.load();
          music.play();
          this.$buefy.dialog.confirm({
            message: this.nameInputCheck(req.name) + '様より参加リクエストが送られました。承認しますか？',
            confirmText: 'はい',
            cancelText: 'いいえ',
            canCancel: ['button'],
            onConfirm: () => {
              this.$buefy.toast.open(this.nameInputCheck(req.name) + '様のリクエストを承認いたしました。')
              reqData.flg = true
              this.$store.dispatch('webRTC/setRequestData', reqData)
            },
            onCancel: () => {
              this.$buefy.toast.open(this.nameInputCheck(req.name) + '様のリクエストを否認いたしました。')
              this.$store.dispatch('webRTC/setRequestData', reqData)
            }
          })
          let reqData = this.$_.cloneDeep(req)
        }
      }
    },
    nameInputCheck (name) {
      if (name) {
        return name
      } else {
        return '匿名ユーザー'
      }
    },
    setProfile (data, type) {
      console.debug('*** Start *** setProfile')
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
      console.debug('*** End *** setProfile')
    },
    async playVideo (event) {
      await event.target.play()
    },
    copyLink () {
      this.copyUrl = process.env.OWN_ENDPOINT + '/videointerview/' + this.user.companyID + '_' + this.user.userHash + '/rooms?openExternalBrowser=1'
      setTimeout(() => {
        var codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        var successful = document.execCommand('copy')
        if (successful && this.copyUrl.indexOf('undefined') == -1) {
          console.info('success')
          this.$buefy.toast.open({
            message: '共有リンクをクリップボードにコピーしました。',
            type: 'is-primary'
          })
        } else {
          console.error('error')
          this.$buefy.toast.open({
            message: '共有リンクをクリップボードにコピーできませんでした。',
            type: 'is-danger'
          })
        }
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      }, 500)
    },
    nextStep() {
      this.prepareStep = 1
      let uriParam = this.user.companyID + '_' + this.user.userHash
      setTimeout (() => {
        // 動画リソースを生成する
        // DOM要素が取得できるまで繰り返す
        var count = 0
        var id = setInterval(() => {
          var localVideo = document.getElementById('pre_local_video')
          if (localVideo) {
            // カメラとマイクを起動してストリームを作成する
            this.$store.dispatch('webRTC/setVideo', {
              room : uriParam,
              video: localVideo,
              connect: false
            })
            clearInterval(id)
          }
          count++
          if (count == 50) clearInterval(id)
        }, 200)
        // 待機ルームに入る
        this.$store.dispatch('webRTC/waitingConnect')
        var count2 = 0
        var id2 = setInterval(() => {
          if (this.waitingPeer && this.waitingPeer.open && this.waitingRoom) {
            clearInterval(id2)
          } else {
            this.$store.dispatch('webRTC/waitingConnect')
          }
          count2++
          if (count2 == 10) clearInterval(id2)
        }, 1000);
      }, 500)
    },
    prevStep() {
      this.prepareStep = 0
      this.$store.dispatch('webRTC/waitingDisconnect')
    },
    startConnect () {
      this.$nextTick(function () {
        let uriParam = this.user.companyID + '_' + this.user.userHash
        this.isStart = true
        setTimeout (() => {
          // 動画リソースを生成する
          var localVideo = document.getElementById('local_video')
          this.$store.dispatch('webRTC/setVideo', {
            room : uriParam,
            video: localVideo,
            connect: true,
            userName: this.inputs.inputName,
            peerId: this.peerId,
          })
          // カメラとマイクを起動してストリームを作成する
        }, 300)
      })
    },
    shareScreen (flg) {
      this.isShare = flg
      if (this.isShare) {
        this.$nextTick(() => {
          let uriParam = this.user.companyID + '_' + this.user.userHash
          setTimeout (() => {
            let localVideo = document.getElementById('local_video_share')
            this.$store.dispatch('webRTC/setVideoShare', {
              room : uriParam,
              video: localVideo
            })
          }, 300)
        })
      } else {
        this.$store.dispatch('webRTC/endCallShare')
      }
    },
    getStyleVideo (len, id) {
      if (this.bigId != id) {
        let w, h
        switch (len) {
          case 1:
            w = '100%'
            h = '100%'
            break
          case 2:
            w = 'calc(100% / 2)'
            h = '100%'
            break
          case 3:
          case 4:
            w = 'calc(100% / 2)'
            h = 'calc(100% / 2)'
            break
          case 5:
          case 6:
            w = 'calc(100% / 3)'
            h = 'calc(100% / 2)'
            break
          case 7:
          case 8:
          case 9:
            w = 'calc(100% / 3)'
            h = 'calc(100% / 3)'
            break
          case 10:
          case 11:
          case 12:
          default:
            w = 'calc(100% / 4)'
            h = 'calc(100% / 3)'
            break
        }
        return { width: w, height: h }
      }
    },
    bigVideo (id) {
      if (this.bigId === id) {
        this.bigId = null
      } else {
        this.bigId = id
      }
    },
    onMouseStream (index) {
      this.mouseOverIndex = index
    },
    outMouseStream (index) {
      if (this.mouseOverIndex == index) this.mouseOverIndex = null
    },
    showStream: function (id) {
      if (this.bigId == null ||
        this.bigId == id ||
        this.remoteStreams.filter(
          v => v.id == this.bigId).length === 0) return true
      else false
    },
    changeChatModal (flg) {
      this.isShowChat = flg
    },
    sendMessage (message) {
      this.$store.dispatch('webRTC/sendMessage', message)
    },
    unReadChange (param) {
      if (param.index != null) {
        this.$set(this.unRead, 'index', param.index)
      }
      if (param.count != null) {
        this.$set(this.unRead, 'count', param.count)
      }
      if (param.date != null) {
        this.$set(this.unRead, 'date', param.date)
      }
      if (param.by_person != null) {
        this.$set(this.unRead, 'by_person', param.by_person)
      }
    },
  },
  beforeDestroy () {
    this.$store.dispatch('webRTC/endCall')
    this.$store.dispatch('webRTC/waitingDisconnect')
  },
}
</script>

<style scoped>
.container-list {
  height: 100vh;
  width: calc(100% - 205px);
  position: relative;
}
.container-list-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
  position: relative;
}
.video-body {
  height: calc(100% - 64px);
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.-black {
  background: #111;
}
.start-box {
  position: relative;
  width: 512px;
  height: 512px;
  margin: 0 auto;
  border: solid thin #ccc;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background: #fefefe;
  border-radius: 8px;
  padding: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.video-size-remote {
  width: 100%;
  height: 100%;
}
#pre_local_video {
  transform: scale(-1, 1);
}
#local_video {
  transform: scale(-1, 1);
}
.balloon-msg {
  border-radius: 10px;
  width: 100%;
  padding: 7px;
  background: aliceblue;
  position: relative;
  font-size: 12px;
  text-align: left;
}
.text-area {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 200px;
  height: 40px;
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
}
.button-menu {
  position: absolute;
  z-index: 301;
  bottom: 0;
  width: 100%;
  height: 100px;
}
.start-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: green;
  color: white;
  border: none;
  margin: 15px;
}
.hangup-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: red;
  color: white;
  border: none;
  margin: 15px;
}
.mute-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.blind-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.link-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.8);
  color: white;
  border: none;
  margin: 15px;
}
.setting-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.8);
  color: white;
  border: none;
  margin: 15px;
}
.drawer-menu {
  position: absolute;
  top: 64px;
  right: 0;
  height: calc(100% - 64px);
  width: 40%;
  min-width: 400px;
  background: #FEFEFE;
  padding: 16px;
  z-index: 301;
}
.video-header {
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: solid thin #eee;
}
.drawer-back {
  height: calc(100% - 64px);
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 200;
  top: 64px;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.big-video {
  position: fixed;
  z-index: 300;
  top : 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #111;
}
.-button-menu-big {
  position: fixed;
  z-index: 301;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100px;
}
.off-video {
  border: none;
  pointer-events: none;
  display: none;
}
.video-frame {
  position: relative;
  width: 100%;
  height: 100%;
}
.mouse-over-blind {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.3); 
}
.mouse-over-pin {
  position: absolute;
  width: 40px;
  height: 40px;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
}
.video-user-name {
  position: absolute;
  left: 0px;
  bottom: 0px;
  color: white;
}
.chat-view {
  position: fixed;
  height: 100%;
  right: 0;
  z-index: 302;
}
.chat-enter-active, .chat-leave-active {
  transform: translateX(0);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.chat-enter, .chat-leave-to {
  transform: translateX(320px);
}
.total-unread {
  position: absolute;
  top: -8px;
  right: -8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12.5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background: #EE2C98;
}
.unread {
  position: absolute;
  top: -32px;
  right: -8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12.5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background: #EE2C98;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VideoView/VideoView.vue